import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type QuestionProgressState = {
    questionProgress?: number,
    questionPages?: number,
    currentPage?: number
};

const initialState: QuestionProgressState = {
    questionProgress: 0,
    questionPages: 0,
    currentPage: 0
};

export const questionProgressSlice = createSlice({
    name: 'questionProgress',
    initialState,
    reducers: {
        setQuestionProgress: (state, action: PayloadAction<QuestionProgressState>) => {
            state.questionProgress = action.payload.questionProgress;
        },
        setQuestionPages: (state, action: PayloadAction<QuestionProgressState>) => {
            state.questionPages = action.payload.questionPages;
        },
        setCurrentPage: (state, action: PayloadAction<QuestionProgressState>) => {
            state.currentPage = action.payload.currentPage;
        },
        clearQuestionProgress: () => ({
            ...initialState
        })
    }
});

export const { setQuestionProgress, setQuestionPages, setCurrentPage, clearQuestionProgress } = questionProgressSlice.actions;

export default questionProgressSlice.reducer;
